module.exports = __webpack_public_path__ + "img/transparent_pdf.b3dfd675.svg";